import { render, staticRenderFns } from "./InventoryBoxContext.vue?vue&type=template&id=9f08ca12&scoped=true&"
import script from "./InventoryBoxContext.vue?vue&type=script&lang=js&"
export * from "./InventoryBoxContext.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f08ca12",
  null
  
)

export default component.exports